import React from 'react';
import { openExternalLinkSimple } from 'utils/openExternalLink';
import SignUpFormContainer from 'components/LoginSignUp/SignUpFormContainer';
import CountryProvider from 'providers/CountryProvider';
import RoundedButton from 'components/RoundedButton';
import { Translator } from '../../Translator';
import LoginForm from 'components/LoginSignUp/LoginForm';
import classnames from 'classnames';
import AuthButtons from 'modules/authentication/components/AuthButtons';
import Separator from 'modules/authentication/components/Separator';
import ExternalLink from 'components/organisms/ExternalLink';

const CSS = require('./LoginSignUp.less');

function LoginPart({ loginButtonLoading, onLogin }) {
  return (
    <LoginForm loginButtonLoading={loginButtonLoading} handleSubmit={onLogin} />
  );
}

function SignUpPart({ signupButtonLoading, options, onSignup, showSignupForm, onShowSignupEmail }) {
  if (showSignupForm) {
    return (
      <CountryProvider>
        {
          ({ countries }) => {
            return (
              <SignUpFormContainer
                options={options}
                signupButtonLoading={signupButtonLoading}
                handleSubmit={onSignup}
                countries={countries}
              />

            );
          }
        }
      </CountryProvider>
    );
  }

  return (
    <RoundedButton
      pink
      onClick={onShowSignupEmail}
    >
      {Translator.translate('Forms.Buttons.signUpWithEmail', {}, true, 'Sign up with email')}
    </RoundedButton>
  );
}

const onLinkClick = (e) => {
  openExternalLinkSimple(e.currentTarget.getAttribute('data-link'));
};

function getLink(target: any, text: string) {
  return (
    <button className={CSS.Link} onClick={onLinkClick} data-link={`${URL_API_HOST}${target}`}>{text}</button>
  );
}

function LoginSignUp({ errors, className,
  options, onSignup, onLogin, onShowSignupEmail,
  onShowLogin, showLogin, loginButtonLoading, signupButtonLoading, showSignupForm, companyName, onLoginAsGuest }) {
  const termsAndConditionsLink = getLink(
    '/info/terms-and-conditions/',
    Translator.translate('Forms.TermsAndPolicy.termsAndConditions', {}, true)
  );
  const privacyPolicyLink = getLink('/info/privacy-policy/', Translator.translate('Forms.TermsAndPolicy.privacyPolicy', {}, true));

  return (
    <div className={classnames(CSS.LoginSignUp, { [className]: className })}>
      <AuthButtons isLogin={showLogin} companyName={companyName} />
      <Separator />
      {showLogin &&
        <LoginPart loginButtonLoading={loginButtonLoading} onLogin={onLogin} />}
      {!showLogin &&
        <SignUpPart
          options={options}
          onSignup={onSignup}
          showSignupForm={showSignupForm}
          onShowSignupEmail={onShowSignupEmail}
          signupButtonLoading={signupButtonLoading}
        />
      }
      {errors &&
        <div className={CSS.errors}>
          {errors.validation}
        </div>
      }
      {
        onLoginAsGuest &&
        <RoundedButton onClick={onLoginAsGuest} invertedBorder className={CSS.GuestLogin}>
          Continue as guest
        </RoundedButton>
      }
      {showLogin &&
        <div className={CSS.Links}>
          <button className={CSS.LinkButton} onClick={onShowSignupEmail}>
            {Translator.translate(
              'Forms.Buttons.noAccountSignUpHere',
              {},
              true,
              'No account yet? Sign up here')
            }
          </button>
          <ExternalLink elementType={'a'} className={`${CSS.LinkButton} ${CSS.ForgotPassword}`} url={`${URL_STOREFRONT_HOST}/password/reset`}>
            {Translator.translate(
              'Forms.ForgetPassword.forgetPassword',
              {}, true,
              'I forgot my password')
            }
          </ExternalLink>
        </div>
      }
      {!showLogin &&
        <div className={CSS.Links}>
          <span>
            {Translator.translate(
              'Forms.Buttons.alreadyHaveAnAccountLogin',
              {},
              true,
              'Already have an account? Log in here')
            }
            {' '}
            <button className={CSS.LinkButton} onClick={onShowLogin}>
              {Translator.translate('Forms.LoginSignup.logInHere')}
            </button>
          </span>
          {showSignupForm &&
            <p className={CSS.Policy}>
              {Translator.translate('Forms.TermsAndPolicy.acceptTermsAndPolicy', {
                termsAndConditionsLink,
                privacyPolicyLink,
              })}
            </p>
          }
        </div>
      }
    </div>
  );
}

export default LoginSignUp;
